export const CREATED = 'CREATED'
export const TO_EMAIL = 'TO_EMAIL'
export const REGISTERED = 'REGISTERED'